export const getStepName = (
  tourName: string,
  actionName: string = '',
  actionNumber: number,
): string => `${tourName}-${actionName}-step${actionNumber}`;
